module.exports = __webpack_public_path__ + "img/340-fcc576.png";